export const InvestmentColumns = [
  {
    id: "actions",
    title: "Actions",
  },
  {
    id: "investor_name",
    title: "Name",
  },
  {
    id: "date",
    title: "Date",
  },
  {
    id: "amount",
    title: "Amount",
  },
];
